/*
 * @providesModule HowToLevelUpModal
 *
 */

import React from 'react';

// import _ from 'lodash';
import {FTUE_LEVELS_VIEW} from 'AWSConstants';
import AWSManager from 'AWSManager';
import I18n from 'INTL';
import PropTypes from 'prop-types';
import Label from 'Label';
import ModalNavigationController from 'ModalNavigationController';
import PushButton from 'PushButton';
import Preferences from 'Preferences';
import SkillzStyle from 'SkillzStyle';
import SkillzImage from 'SkillzImage';
import SKZConstants from 'SKZConstants';
import HeaderModal from 'HeaderModal';
import styles from 'HowToLevelUpModalStyle';

import {View} from 'react-native';
import {FTUE_LEVELS_KEY} from 'UserPropertiesConstants';
import {updateUserProperties} from 'UserPropertiesController';

const {btnGradientOne, viewCornerRadiusPrimary} = SkillzStyle.fullStyles;

export default class HowToLevelUpModal extends React.PureComponent {
  static propTypes = {
    testID: PropTypes.string,
    style: PropTypes.object,
    dismiss: PropTypes.func,
  };

  static defaultProps: {
    style: null;
  };

  _dismissModal = () => {
    Preferences.set({[SKZConstants.SKZ_HAS_SEEN_HOW_TO_LEVEL_UP_MODAL]: true});
    updateUserProperties(FTUE_LEVELS_KEY, 'true');
    AWSManager.trackEvent(FTUE_LEVELS_VIEW);
    ModalNavigationController.hideModal();
  };

  _renderModalBody(): React.ReactNode {
    return (
      <View testID={this.props.testID} style={styles.modalBody}>
        {this._renderDiagram()}
        {this._renderDiagramProgress()}
        {this._renderCaption()}
        {this._renderOkButton()}
      </View>
    );
  }

  _renderDiagram(): React.ReactNode {
    return (
      <View style={styles.diagramContainer}>
        {this._renderIconAndTitle(
          'ic_arrow_outline_levels_skz.png',
          I18n.message('Play\nMatches'),
          'Play Matches'
        )}
        {this._renderIconAndTitle(
          'ic_experience_levels_skz.png',
          I18n.message('Earn\nExperience'),
          'Earn Experience'
        )}
        {this._renderIconAndTitle(
          'ic_level_up_levels_skz.png',
          I18n.message('Level\nUp'),
          'Level Up'
        )}
      </View>
    );
  }

  _renderDiagramProgress(): React.ReactNode {
    return (
      <View style={styles.diagramProgressOuterContainer}>
        <View style={styles.diagramProgressContainer}>
          <View style={styles.diagramShape}>
            <View style={styles.circle} />
          </View>
          <View style={styles.diagramShape}>
            <View style={styles.triangle} />
          </View>
          <View style={styles.diagramShape}>
            <View style={styles.triangle} />
          </View>
        </View>
        <View style={styles.diagramProgressLine} />
      </View>
    );
  }

  _renderIconAndTitle(
    imageSource: string,
    title: string,
    accessibilityLabel: string = title
  ): React.ReactNode {
    return (
      <View style={styles.iconAndTitle}>
        <SkillzImage style={styles.diagramIcon} source={imageSource} resizeMode={'cover'} />
        <Label
          style={styles.diagramLabel}
          allowFontScaling={false}
          adjustsFontSizeToFit={false}
          numberOfLines={2}
          accessible={true}
          accessibilityLabel={accessibilityLabel}
        >
          {title}
        </Label>
      </View>
    );
  }

  _renderCaption(): React.ReactNode {
    return <Label style={styles.caption}>{I18n.message('Win matches to level up faster!')}</Label>;
  }

  _renderOkButton(): React.ReactNode {
    const testID = this.props.testID ? `${this.props.testID}_button` : undefined;
    return (
      <PushButton
        testID={testID}
        style={styles.button}
        onPress={this._dismissModal}
        cornerRadius={viewCornerRadiusPrimary.borderRadius}
        colors={btnGradientOne}
        title={I18n.message('OK')}
        textStyle={styles.buttonText}
      />
    );
  }

  render(): React.ReactNode {
    return (
      <HeaderModal title={I18n.message('How to Level Up')} showShadow onDone={this._dismissModal}>
        {this._renderModalBody()}
      </HeaderModal>
    );
  }
}
